<template>
  <div class="page">
    <div class="banner">
      <img src="../../assets/images/news/banner.png" />
    </div>

    <article>
      <div class="caption">
        <h2>新闻动态</h2>
        <span>NEWS</span>
      </div>

      <div class="content">
        <div v-for="item in list" :key="item.id" class="item">
          <h4>{{item.title}}</h4>
          <h5>{{date2Str(item.create_time, "MM/dd")}}</h5>
          <p>
            {{eraseHtml(item.content)}}
          </p>
          <a :href="'/news/detail/'+item.id">查看详情 →</a>
        </div>
      </div>
    </article>
  </div>
</template>

<script>
import { eraseHtml, date2Str } from "@/assets/js/utils.js";
import newsList from "./newsList";

export default {
  data() {
    return {
      list: newsList.sort((x, y) => y.id - x.id)
    };
  },
  mounted() {
    // this.$router.push("../news/detail?id=1");
  },
  methods: {
    eraseHtml,
    date2Str
    // eraseHtml: function(html) {
    //   return html.replace(/<[^>]+>/g, "");
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";

$SIZE_SPACE: 5vw;

.banner img {
  width: 100%;
}

.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  > .banner {
    margin-bottom: 40px;
  }

  > article {
    display: flex;
    flex-direction: column;
    // width: $SIZE_PAGE_WIDTH;

    > .caption {
      display: flex;
      flex-direction: column;
      align-items: center;
      > h2 {
        display: inline-block;
        border-bottom: 2px solid #666666;
        padding-bottom: 5px;
        margin-bottom: 0.1rem;
      }

      span {
        font-size: 14px;
        font-weight: lighter;
      }
    }

    > .content {
      display: flex;
      flex-direction: row;
      // justify-content: space-between;
      flex-wrap: wrap;
      width: $SIZE_PAGE_WIDTH;
      margin-top: 20px;

      > .item {
        width: ($SIZE_PAGE_WIDTH + $SIZE_SPACE) / 3;
        margin-bottom: 60px;

        &:nth-child(3n) {
          width: ($SIZE_PAGE_WIDTH - $SIZE_SPACE * 2) / 3;
        }

        > h4 {
          margin: 10px 0;
          width: ($SIZE_PAGE_WIDTH - $SIZE_SPACE * 2) / 3;
          font-size: 0.08rem;
          color: rgba(51, 51, 51, 1);
          line-height: 0.09rem;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1;
          overflow: hidden;
        }

        > h5 {
          margin: 10px 0;
          font-size: 0.05rem;
          color: rgba(136, 136, 136, 1);
          line-height: 0.07rem;
        }

        > p {
          margin: 20px 0;
          font-size: 0.06rem;
          color: rgba(102, 102, 102, 1);
          line-height: 0.13rem;
          width: ($SIZE_PAGE_WIDTH - $SIZE_SPACE * 2) / 3;

          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
        }

        > a {
          display: block;
          width: 50%;
          border-bottom: 1px solid gray;
          font-size: 0.06rem;
          color: rgba(51, 51, 51, 1);
          padding-bottom: 5px;
          text-decoration: none;

          &:hover {
            color: #0ab2d2;
          }
        }
      }
    }
  }
}
</style>